import { c as _c } from "react/compiler-runtime";
import css from './cache.module.scss';
export function Cache() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={css.cache}><p className={css.label}>Cache</p><p className={css.value}>Edge CDN</p><p className={css.note}>1 hour TTL</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}